// extracted by mini-css-extract-plugin
export default {"screenshotModal":"style-module__FHwZE"};